import { type ItemOf } from '@shared/board'
import { clsx } from 'clsx'
import { DRAG_HANDLE } from '../classes'
import { useBoardCtx } from '../context'
import { fileUrl } from '../upload'

export function ImageView({ item, selected }: { item: ItemOf<'image'>; selected: boolean }) {
  const { boardId } = useBoardCtx()
  return (
    <div
      className={clsx(
        'moot-node relative cursor-grab overflow-hidden rounded-md border bg-surface-2 shadow-sm active:cursor-grabbing',
        DRAG_HANDLE,
        selected ? 'border-(--focus)' : 'border-line',
      )}
      style={{ width: item.w, height: item.h }}
    >
      <img
        src={fileUrl(boardId, item.data.fileKey)}
        alt={item.data.name}
        draggable={false}
        className="block size-full object-cover select-none"
      />
    </div>
  )
}
